export const generalUtils = {
  isTestUser: (email: string): boolean => email.includes("@doorloop.com")
};
